module.exports = __webpack_public_path__ + "img/antes_despues_239.78118406.png";